<div class="overlay" (click)="clickOverlay()" [ngStyle]="{ display: isOpen ? 'block' : 'none' }"></div>
<div class="modal temp-mobile-w" [ngClass]="modal" [ngStyle]="toggleModal">
	<div class="modal__content">
		<ng-content></ng-content>
	</div>
</div>
